import React, { useMemo, useState } from "react";

function isValidJAN13(code) {
  if (!/^\d{13}$/.test(code)) return false;
  const d = code.split("").map(Number);
  const sum = d.slice(0, 12).reduce((acc, n, i) => acc + n * (i % 2 === 0 ? 1 : 3), 0);
  const check = (10 - (sum % 10)) % 10;
  return check === d[12];
}

export default function JanManual({ onSubmit, isAU = false }) {
  const [val, setVal] = useState("");
  const cleaned = useMemo(() => val.replace(/[^\d]/g, "").slice(0, 13), [val]);
  const ok = cleaned.length === 13 && isValidJAN13(cleaned);

  return (
    <div style={{ display: "grid", gap: 8 }}>
      <div style={{ fontWeight: 900 }}>{isAU ? "Enter barcode manually" : "JANを手入力"}</div>

      <input
        value={val}
        onChange={(e) => setVal(e.target.value)}
        inputMode="numeric"
        pattern="[0-9]*"
        placeholder={isAU ? "13 digits (e.g. 4901234567890)" : "13桁（例: 4901234567890）"}
        style={{ fontSize: 18, padding: 10, borderRadius: 10, border: "1px solid #ddd" }}
      />

      <div style={{ fontSize: 12, opacity: 0.8 }}>
        {isAU
          ? (cleaned.length < 13 ? `${13 - cleaned.length} more digit(s)` : ok ? "OK" : "Barcode may be invalid")
          : (cleaned.length < 13 ? `あと${13 - cleaned.length}桁` : ok ? "OK" : "JANが正しくない可能性")}
      </div>

      <button
        onClick={() => ok && onSubmit(cleaned)}
        disabled={!ok}
        style={{ padding: 12, borderRadius: 10, fontWeight: 900 }}
      >
        {isAU ? "Confirm" : "確定"}
      </button>
    </div>
  );
}
